import { logger } from "@/lib/logger";

import type { AuthInstance } from "../types";

export const getCurrentToken =
  (client: AuthInstance) => async (): Promise<string> => {
    try {
      return (await client.currentSession()).getIdToken().getJwtToken();
    } catch (err) {
      logger.warn("Auth Session Error: ", err);
      return "";
    }
  };
